import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { MUTATION_KEYS } from "./queryKeys";
import Api from "../api/Api";
import { IAdvancedAnalyticsApiPayload } from "../types/chart";

type GetAdvancedAnalyticsResponse = {
    Result?: {
        img: string;
        links?: string[];
    };
    Error?: any;
};

export default function useGetAdvancedAnalyticsMutation(): UseMutationResult<
    GetAdvancedAnalyticsResponse,
    Error,
    IAdvancedAnalyticsApiPayload,
    unknown
> {
    return useMutation({
        mutationKey: [MUTATION_KEYS.chart.getAdvancedAnalytics],
        mutationFn: async (payload: IAdvancedAnalyticsApiPayload) => {
            try {
                return await Api.chart.getAdvancedAnalytics(payload);
            } catch (error) {
                console.error('Error getting advanced analytics:', error);
                throw error;
            }
        }
    });
}
